// 日本語テーブル（機械翻訳・未校正 — ruling G4）。
// The Japanese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  title: "名前入りスマホケース",
  beta: "ベータ版",
  phone: "スマホ機種",
  forPhone: (name) => `${name} 用ケース`,
  material: "素材",
  materials: {
    flex: "柔軟（TPU）",
    rigid: "硬質（PETG）",
  },
  thick: "厚さ",
  thicks: {
    slim: "スリム",
    standard: "スタンダード",
    tough: "タフ",
  },
  fit: "フィット",
  fits: {
    tight: "きつめ",
    normal: "ジャスト",
  },
  src: "裏面アート",
  textHint: (lines, chars) => `最大 ${lines} 行、各行 ${chars} 文字まで`,
  loadingFont: (family, got, total) => (total > 0 ? `${family} を読み込み中 ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `${family} を読み込み中 ${got.toFixed(1)} MB`),
  finish: "アートスタイル",
  finishes: {
    flush: "フラッシュ、2色",
  },
  turn: "向き",
  turns: {
    "0": "横書き",
    "90": "縦書き",
  },
  scale: "サイズ",
  pos: "位置",
  position: (v) => (Math.abs(v) < 0.005 ? '中央' : `${v > 0 ? '上部' : '下部'} ${Math.round(Math.abs(v) * 100)}%`),
  needFile: "SVGファイルを選んでください — 端末内に留まり、どこにも送信されません",
  artKept: "アートはこのタブ内にだけ存在します — 再読み込み後はファイルを再選択してください",
  keptOld: "（引き続き前のアートを使用）",
  thumb: "読み込んだアートのプレビュー",
  shareNoArt: "このリンクにSVGファイルは含まれません — 開く人がファイルを選ぶ必要があります",
  linkNeedsArt: "このデザインはファイルのアートを使いますが、リンクには含まれません — SVGファイルを選んで追加してください",
  gColour: "カラー",
  colourCase: "ケースの色",
  colourArt: "アートの色",
  notes: {
    untested: (name, material) => `${name} は ${material} でプリントテストしていません`,
    settings: "裏面向きでプリント、サポートなし、レイヤー高さ0.2 mm",
    tested: (name, material) => `${name} は ${material} でプリントテスト済み`,
    proud: (mm) => `カメラが背面から ${mm} mm 盛り上がっています — 画面を上に置くと傾きます`,
    flush: "フラッシュの2色アートにはマルチカラープリンターと3MFファイルが必要です（STLにアートはなく閉じています）",
    engraved: "彫刻アートは1色でフィラメント交換不要 — STLでも3MFでもプリントできます",
    pla: "PLAはお勧めしません — 装着時に割れ、スマホの発熱で柔らかくなります — TPUかPETGをご使用ください",
    terms: "学習と個人使用向け — ご自身の責任でご利用ください",
  },
  size: (x, y, z) => `ケースサイズ ${x.toFixed(1)} × ${y.toFixed(1)} × ${z.toFixed(1)} mm`,
  grams: (g) => `重さ約 ${Math.round(g)} g`,
  views: {
    back: "裏",
    front: "表",
    side: "側面",
  },
  problem: {
    "no-art": "プリントする文字がありません — 無地のケースになります",
    "thin-text": "文字がとても細い — プリントできない線があるかもしれません — より大きいサイズか少ない文字数でお試しください",
    "same-colour": "アートの色がケースの色と同じです — アートが見えなくなります",
    "thin-parts": "アートの太い部分に細い線が付いています — スライサーで切り捨てられる可能性があります",
    dropped: (p) => `薄すぎてプリントできない部分 ${p.n} 個をアートから落としました`,
    "all-thin": "アートがこのサイズに対して薄すぎます — ダウンロードできません",
    "art-too-complex": "アートが複雑すぎます — ダウンロードできません",
    "wide-groove": (p) => `溝が ${p.mm} mm より広いと、それを塞ぐレイヤーは空中にプリントされます — 裏面が平らにならないことがあります — アートを小さくするかフラッシュ2色にしてください`,
  },
  dlstl: "STL",
  copied: "コピーしました",
  fatal: "計算機を読み込めません — ページを再読み込みしてください",
  buildTimeout: "生成が10秒で終わらず再開しました — 文字を減らすか別のフォントをお試しください",
  aboutH2: "名前入りスマホケースの仕組み",
  aboutP1: "iPhone 16 Pro Max または iPhone 16 を選び、名前やロゴの SVG ファイルを配置して、3MF か STL をダウンロードしてプリント。ケースは裏面向き・サポートなしでプリントでき、縁が画面端をわずかに覆って本体を保持し、カメラ・Camera Control ボタン・充電ポート用の開口があります。",
  aboutP2: "フラットタイプは2色で、アートがケース面と同じ高さのもう一色になります — マルチカラー機が必要です。彫刻タイプは1色でプリントできます。SVG ファイルは端末から出ず、どこにも送信されず、コピーしたリンクにも含まれません。",
  aboutPrint: "フィットの数値（本体まわりの隙間、縁の深さ）は他のデザイナーの慣行に基づきます。実機でのプリント・装着検証はまだです。OrcaSlicer でのシミュレーションとスライスのみ通過済みです。",
  aboutTerms: "このツールは学習および個人利用のためのものです。電話メーカーの認証を受けていません。プリントしたケースは合わなかったり、保護にならないことがあります。リスクはすべて利用者にあります。",
  aboutTrademark: "iPhone は Apple Inc. の商標です。このツールは Apple 製ではなく、Apple とは関係ありません。型番は、このケースがどの機種用かを示すためだけに使っています。",
};
export default S;
